module.exports = __webpack_public_path__ + "img/curv-shape.8c7f9115.svg";